export default "__VITE_ASSET__CsNLYL8C__"